import {Injectable, Pipe, PipeTransform} from '@angular/core';
import {SiteModel} from '../models/site.model';

@Pipe({
  name: 'lbaSwitchSiteFilter',
})
@Injectable()
export class SelectSitePipe implements PipeTransform {

  transform(sites: Array<SiteModel>, siteStr: string): any {
    siteStr = siteStr.toLowerCase();
    const filteredSites: Array<SiteModel> = [];
    if (siteStr.length === 0) {
      return sites;
    }
    if (sites) {
      for (const site of sites){
        if (site.name.toLowerCase().indexOf(siteStr) !== -1 || site.id.toString().indexOf(siteStr) !== -1) {
          filteredSites.push(site);
        }
      }
    }
    return filteredSites;
  }
}
